import { z } from 'zod';
import { esquemaMotivo } from './comunes.js';
/**
 * Ledger de uso y cuotas (F5.3, USAGE-01, plan maestro §12.3 y §12.4).
 *
 * - El ledger acepta eventos al menos una vez y deduplica por id.
 * - El agregado se RECONSTRUYE desde el ledger y se concilia contra el
 *   inventario de archivos: el ledger es el comprobante, no las metricas.
 * - Una eliminacion resta solo cuando se verifico que los bytes ya no estan.
 * - Avisos al acercarse al limite. 70/85/95 es el ejemplo inicial del plan,
 *   para revisar en piloto; cada consultorio puede tener los suyos.
 */
export const UMBRALES_DE_AVISO_POR_DEFECTO = [70, 85, 95];
export const esquemaPoliticaCuota = z
    .object({
    umbrales: z
        .array(z.number().int().min(1).max(100))
        .min(1)
        .max(5)
        .refine((u) => new Set(u).size === u.length, { message: 'Umbrales repetidos' }),
    motivo: esquemaMotivo,
})
    .strict();
// --- F5.4: tableros (USAGE-02, AC-27) ---------------------------------------------
/**
 * Calidad de cada numero que se muestra (plan §12.1):
 * - `medida`: contada de verdad (ledger, registros).
 * - `parcial`: medida, pero con cobertura limitada (p. ej. solo este proceso
 *   desde que arranco). La cobertura lo dice.
 * - `estimacion`: un reparto o modelo. Nunca se presenta como medida.
 */
export const CALIDADES_DE_METRICA = ['medida', 'parcial', 'estimacion'];
//# sourceMappingURL=uso.js.map